import type { RiskWorkspace } from '@app/types'
import type { RiskProfileBaseParams } from '../types/riskProfile.types'
import { DamageState } from '../types/riskProfileSelected.types'

export type UseRiskProfileBaseParamsOptions = {
  metric: string
  selectedWorkspace: RiskWorkspace | null
  areaGroup: string | null
  areas: string[]
  selectedHazardGroups: string[]
  damageStates: DamageState[]
}

export const useRiskProfileBaseParams = ({
  metric,
  selectedWorkspace,
  areaGroup,
  areas,
  selectedHazardGroups,
  damageStates,
}: UseRiskProfileBaseParamsOptions): RiskProfileBaseParams | null => {
  if (selectedWorkspace === null) return null

  return {
    metric,
    workspaceId: selectedWorkspace.id,
    hazards: selectedWorkspace.layers.scenarios,
    regions: selectedWorkspace.regions,
    areaGroup,
    areas,
    selectedHazardGroups,
    damageStates,
  }
}
